import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Route, Switch } from 'react-router-dom';
import Helmet from 'react-helmet';
import _ from 'lodash';
import isEqual from 'react-fast-compare';

import LoginPage from '../pages/LoginPage/LoginPage';
import KioskManagerLoginPage from '../pages/LoginPage/KioskManagerLoginPage';
import LinkUserLoginPage from '../pages/LoginPage/LinkUserLoginPage';
import TermsOfUsePage from '../pages/LoginPage/TermsOfUsePage';
import UpdatePasswordPage from '../pages/LoginPage/UpdatePasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import ConfirmEmailPage from '../pages/ConfirmEmailPage/ConfirmEmailPage';
import Logout from '../containers/Logout/Logout';
import IntlSecureMessageForm from '../containers/SecureMessage/SecureMessageForm';
import VerifyIdentityPage from '../pages/SignUpPage/VerifyIdentityPage/VerifyIdentityPage';
import ProvideEmailPage from '../pages/SignUpPage/ProvideEmailPage/ProvideEmailPage';
import CreateAccountPage from '../pages/SignUpPage/CreateAccountPage/CreateAccountPage';
import AuthRepVerifyIdentityPage from '../pages/SignUpPage/AuthRepVerifyIdentityPage/AuthRepVerifyIdentityPage';
import CompleteQuestionnairePage from '../pages/QuestionnairesPage/CompleteQuestionnairePage';
import { KioskQuestionnairePage } from '../pages/QuestionnairesPage/KioskQuestionnairePage';
import ReviewQuestionnairePage from '../pages/QuestionnairesPage/ReviewQuestionnairePage';
import AddContactPage from '../pages/AddContactPage/AddContactPage';
import EditContactPage from '../pages/EditContactPage/EditContactPage';
import InviteAuthStatementPage
from '../pages/InviteAuthRepPages/InviteAuthStatementPage/InviteAuthStatementPage';
import PinRequiredPage from '../pages/InviteAuthRepPages/PinRequiredPage/PinRequiredPage';
import { QuestionnaireScoringPage } from '../pages/QuestionnairesPage/QuestionnaireScoringPage';
import { KioskQuestionnaireScoringPage } from '../pages/QuestionnairesPage/KioskQuestionnaireScoringPage';
import PatientKioskQuestionnairesPage from '../pages/QuestionnairesPage/PatientKioskQuestionnairesPage';
import SsoLogoutPage from '../pages/LoginPage/SingleSignOnLogoutPage';
import * as MsgBarActions from '../redux/modules/system-shared/message-bar-action-creator';


import Menu from './Menu/Menu';
import MasterFooter from './Footer/MasterFooter';
import HomePage from '../pages/HomePage/HomePage';
import { links } from '../shared/links';


class PageLayout extends React.Component {
  constructor() {
    super();
    this.state = {
      linkDict: _.chain(links).keyBy('to').mapValues((v) => v).value(),
    };
  }

  componentDidMount() {
    const { location, history } = this.props;
    if (window.piwik) {
      this.recordVisit(location);
      let currentPage = {
        pathname: '',
        action: '',
      };
      history.listen((loc, action) => {
        const pageInfo = { pathname: loc.pathname, action };
        if (isEqual(currentPage, pageInfo)) {
          return;
        }
        currentPage = pageInfo;
        this.recordVisit(loc);
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.onRouteChange(nextProps);
    }
  }

  shouldComponentUpdate = (nextProps) => {
    if (nextProps.keepMessageDisplay) {
      return false;
    }
    return true;
  }

  onRouteChange = (nextProps) => {
    if (nextProps.keepMessageDisplay || this.props.keepMessageDisplay) {
      this.props.dispatch(MsgBarActions.setMessageFlagDismiss());
    } else {
      this.props.dispatch(MsgBarActions.dismissMessage());
    }
  }

  recordVisit = (location) => {
    const linkKey = location.pathname.toLowerCase();
    const pageTitle = this.state.linkDict[linkKey];
    if (pageTitle) {
      window.piwik.push(['setCustomUrl', linkKey]);
      window.piwik.push(['setDocumentTitle', pageTitle.piwikTitle]);
      window.piwik.push(['trackPageView']);
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { facilityShortName } = this.props;
    const pageTitle = this.state.linkDict[this.props.location.pathname.toLowerCase()];
    return (
      <div className="container" id="container">
        <a href="#content" id="skiplink" className="sr-only sr-only-focusable">Skip to Content</a>
        <Helmet
          htmlAttributes={{ lang: this.props.language }}
          title={
            pageTitle && facilityShortName ?
              formatMessage(pageTitle, { facilityShortName, patientPortal: formatMessage(links.siteName) }) :
              null
          }
          link={[
            { href: this.props.theme, rel: 'stylesheet', type: 'text/css' },
          ]}
        >
        </Helmet>
        <Menu />
        <div className="page-layout-view">
          <Switch>
            <Route path="/login" component={LoginPage} />
            <Route path="/kioskLogin" component={KioskManagerLoginPage} />
            <Route path="/linkLogin" component={LinkUserLoginPage} />
            <Route path="/termsOfUse" component={TermsOfUsePage} />
            <Route path="/update-password" component={UpdatePasswordPage} />
            <Route path="/reset-password" component={ResetPasswordPage} />
            <Route path="/confirm-email" component={ConfirmEmailPage} />
            <Route path="/logout" component={Logout} />
            <Route path="/secure-message" component={IntlSecureMessageForm} />
            <Route path="/sign-up" component={VerifyIdentityPage} />
            <Route path="/provide-email" component={ProvideEmailPage} />
            <Route path="/create-account" component={CreateAccountPage} />
            <Route path="/auth-rep-sign-up" component={AuthRepVerifyIdentityPage} />
            <Route path="/ssoLogout" component={SsoLogoutPage} />

            <Route path="/kioskQuestionnaires" component={KioskQuestionnairePage} />
            <Route path="/complete-kiosk-questionnaire"
              module="questionnaires"
              component={CompleteQuestionnairePage}
            />
            <Route path="/complete-questionnaire"
              module="questionnaires"
              component={CompleteQuestionnairePage}
            />
            <Route path="/kiosk-questionnaire-scoring"
              module="questionnaires" component={KioskQuestionnaireScoringPage}
            />
            <Route path="/questionnaire-scoring"
              module="questionnaires" component={QuestionnaireScoringPage}
            />
            <Route path="/review-questionnaire"
              module="questionnaires"
              component={ReviewQuestionnairePage}
            />
            <Route path="/patientKioskQuestionnaires" module="questionnaires"
              component={PatientKioskQuestionnairesPage}
            />
            <Route path="/add-contact" component={AddContactPage} />
            <Route path="/edit-contact" component={EditContactPage} />
            <Route path="/invite-auth-statement" component={InviteAuthStatementPage} />
            <Route path="/contact-pin" component={PinRequiredPage} />
            <Route path="/" component={HomePage} />
          </Switch>
        </div>
        <MasterFooter />
      </div>
    );
  }
}

PageLayout.propTypes = {
  intl: PropTypes.object,
  language: PropTypes.string,
  theme: PropTypes.string,
  keepMessageDisplay: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  facilityShortName: PropTypes.string,
};

const mapStateToProps = (state) => ({
  language: state.language.languageCode,
  theme: state.facility ? state.facility.theme : '',
  keepMessageDisplay: state.messageDisplayBar.keepDisplay,
  facilityShortName: state.facility.facilityShortName,
});

export default connect(mapStateToProps)(injectIntl(PageLayout));